<template>
<el-container>
  <div v-if="ismobile === false">
    <publicHeader :currencyShow="currencyShow" @hotelLanguage="hotelLanguage"></publicHeader>
  </div>
  <div v-else>
    <div style="height:60px; background-color:rgba(79, 76, 76, 1);">
      <i class="el-icon-arrow-left" style="color: white;height: 20px; width: 20px; font-size: 20px; position: absolute;margin: 20px 0px 20px 20px;" @click="goback()"></i>
      <div style="font-weight: 650; font-style: normal; font-size: 16px; color: #FFFFFF; text-align: center; height: 60px; line-height: 60px;">{{$t('myBookings')}}</div>
    </div>
  </div>
  <el-main>
      <div class="main" :style="{minHeight: `${mainMinHeight}px`}">
          <publicAccountMenu></publicAccountMenu>
          <!-- 我的行程 -->
          <div class="account-show">
            <div class="account-center">
              <div class="account-data-info">
                <div class="account-data-search" v-if="ismobile === false">
                    {{$t('bookingReference')}}
                    <!-- <input type="text" v-model="keyword" class="el-input__inner" @input="checkKeyword"> -->
                    <!-- <input type="text" v-model="keyword" class="el-input__inner" @input="checkKeyword" v-if="ismobile === false"> -->
                    <el-input class="mobile-keyword" v-model="keyword"  @input="checkKeyword" @keyup.enter.native="handleKeyUp">
                      <i slot="prefix" class="el-input__icon el-icon-close" style="font-size:15px;" @click="mobileClearOrderNo"></i>
                    </el-input>
                    <button class="account-button button-search" @click="searchOrderNo">{{$t('search')}}</button>
                    <!-- <button class="account-button button-report" @click="clearOrderNo" v-if="ismobile === false">{{$t('clear')}}</button> -->
                </div>
                <div  class="account-data-search" v-else>
                  <el-input class="mobile-keyword" :style="{ width: `${elementWidth}px` }" :placeholder="$t('bookingReference')" v-model="keyword"  @input="checkKeyword" @keyup.enter.native="handleKeyUp">
                      <i slot="prefix" class="el-input__icon el-icon-close" style="font-size:15px;" @click="mobileClearOrderNo"></i>
                    </el-input>
                    <button class="account-button button-search" @click="searchOrderNo">{{$t('search')}}</button>
                </div>
                <div class="account-data-status account-data-status-pc">
                    <div class="account-data-status-center">
                        <div class="status-first" @click="clickActive('allOrders')" :class="{'status-active':allOrdersShow}">{{$t('allOrders')}}</div>
                        <div @click="clickActive('waitPay')" :class="{'status-active':waitPayShow}">{{$t('waitPay')}}</div>
                        <div @click="clickActive('upcoming')" :class="{'status-active':upComingShow}">{{$t('upcoming')}}</div>
                        <div class="status-last" @click="clickActive('completed')" :class="{'status-active':completedShow}">{{$t('completed')}}</div>
<!--                              <div class="status-last" @click="clickActive('cancelled')" :class="{'status-active':cancelledShow}">{{$t('cancelled')}}</div>-->
                    </div>
                </div>
                <div class="account-data-empty" v-show="tripEmptyShow">
                  <div><img src="https://res.roompai.com/static/img/account/trip-no.png" class="content-empty-img"></div>
                  <div class="content-empty-text">
                    {{emptyText}}
                  </div>
                </div>
                <div class="account-data-detail" :style="{minHeight: `${listMinHeight}px`}">
                  <el-skeleton :count="5" animated :loading="tripListShow">
                    <template slot="template">
                      <div class="account-data-order account-order-pc">
                        <el-skeleton-item variant="text" class="account-data-order-img"/>
                        <div style="display:inline-block; width:75%;">
                          <div class="account-data-order-info">
                            <el-skeleton-item variant="text" class="account-data-info-top"/>
                            <div :class="'account-data-price-top-'+language" style="width: 44%;float: right;margin: 10px 12px 0px 0px;font-size:13px;text-align: right;line-height: 20px;">
                              <el-skeleton-item variant="text" style='height:20px; '/>
                            </div>
                          </div>
                          <div class="account-data-order-price">
                            <div class="account-data-info-main">
                              <div><el-skeleton-item variant="text" style="width: 75%;" /></div>
                              <div style="overflow: hidden; white-space: nowrap; text-overflow: ellipsis;">
                                <el-skeleton-item variant="text" style="width: 75%;"/>
                              </div>
                              <div><el-skeleton-item variant="text" style="width: 25%;" /></div>
                              <el-skeleton-item variant="text" style="width: 75%;" />
                            </div>
                            <div class="account-data-price-footer">
                              <el-skeleton-item variant="text" style="width: 105px; height: 30px; float: right;"/>
                              <el-skeleton-item variant="text"  class="account-data-price-button" style="width: 105px;height: 40px;float: right; margin-top: 10px;"/>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="account-data-order account-order-mobile">
                        <div class="account-order-info">
                          <el-skeleton-item variant="text" class="account-order-img"/>
                          <div class="account-order-hotel">
                            <div class="account-order-hotel-info" style="width: 97%;">
                              <el-skeleton-item variant="text"/>
                            </div>
                            <div style=" height: 50px; margin-top: 15px; width: 100%;">
                              <div style="width:87%;height: 22px;line-height: 22px;">
                                <div class="account-order-hotel-orderno">
                                  <el-skeleton-item variant="text"/>
                                </div>
                              </div>
                              <div style="width: 87%; float: left;height: 22px; line-height: 22px;">
                                <div class="account-order-hotel-orderdate">
                                  <el-skeleton-item variant="text"/>
                                </div>
                              </div>
                              <div class="account-order-detail"><i class="el-icon-arrow-right" style="color: #999;"></i></div>
                            </div>
                          </div>
                        </div>
                        <div class="account-order-data">
                          <div class="account-order-checkin">
                            <div class="account-order-checkin-date" style="width: 40%;margin: 0px 2%;">
                              <div><el-skeleton-item variant="text" style="height: 10px; margin-top:5px;"/></div>
                              <div style="color:#5392F9"><el-skeleton-item variant="text" style="height: 10px; margin-top:5px;"/></div>
                            </div>
                            <div class="account-order-checkin-line" style="width: 8%;">
                              <i class="el-icon-right" style="color:#999999;"></i>
                            </div>
                            <div class="account-order-checkin-date" style="width: 40%;margin: 0px 2%;">
                              <div><el-skeleton-item variant="text" style="height: 10px; margin-top:5px;"/></div>
                              <div style="color:#5392F9"><el-skeleton-item variant="text" style="height: 10px; margin-top:5px;"/></div>
                            </div>
                          </div>
                          <div class="account-order-night">
                            <div style="width: 90%; margin:0px 5%;"><el-skeleton-item variant="text" style="height: 10px; margin-top:5px;"/></div>
                            <div style="width: 90%; margin:0px 5%;color:#5392F9"><el-skeleton-item variant="text" style="height: 10px; margin-top:5px;"/></div>
                          </div>
                          <div class="account-order-night">
                            <div style="width: 90%; margin:0px 5%;"><el-skeleton-item variant="text" style="height: 10px; margin-top:5px;"/></div>
                            <div style="width: 90%; margin:0px 5%;color:#5392F9"><el-skeleton-item variant="text" style="height: 10px; margin-top:5px;"/></div>
                          </div>
                        </div>
                      </div>
                      <div class="clearBoth order-room-clear"></div>
                    </template>
                    <template>
                      <div v-for="(value, key) in listInfo" :key="key">
                        <div class="account-data-order account-order-pc">
                            <div class="account-data-order-img" v-if="value.pic !== ''">
                              <img :src="value.pic" alt="">
                            </div>
                            <div class="account-data-order-img" v-else>
                              <img :src="value.dpic" alt="">
                              <div class="no-room-img text-font-hidden">{{$t('nopic')}}</div>
                            </div>
                            <div style="display:inline-block; width:75%;">
                            <div class="account-data-order-info">
                                <div class="account-data-info-top" v-if="language === 'zh'">
                                  {{value.hotelname_zh}}
                                  <br>
                                  <el-tooltip style="display: -webkit-box; -webkit-line-clamp: 2; overflow: hidden; text-overflow: ellipsis; max-width: 100%;-webkit-box-orient: vertical;" effect="dark" :content="value.hotelname" placement="top-start">
                                    <span>({{value.hotelname}})</span>
                                  </el-tooltip>
                                </div>
                                <div class="account-data-info-top" v-else>
                                  {{value.hotelname}}
                                </div>
                                <div :class="'account-data-price-top-'+language" style="width: 46%;float: right;margin: 10px 12px 0px 0px;font-size:13px;text-align: right;line-height: 20px;">
                                  <div style='height:20px; '>
                                    <span :class="'tag-order-status-'+language" class="tag-payment" v-if="value.order_status==='1'">{{$t('unpaid')}}</span>
                                    <span :class="'tag-order-status-'+language" class="tag-noconfirm" v-else-if="value.order_status==='2'">{{$t('pending')}}</span>
                                    <span :class="'tag-order-status-'+language" class="tag-confirm" v-else-if="value.order_status==='3' || value.order_status==='6'">{{$t('confirmed')}}</span>
                                    <span :class="'tag-order-status-'+language" class="tag-cancel" v-else>{{$t('cancelled')}}</span>
                                    <span style="color:#303133"> {{$t('bookingReferenceNo')}}</span>
                                    <span style="color:#5392F9">{{value.orderno}}</span>
                                  </div>
                                  <div class="child-pay-tip" v-if="value.childpay !== ''">
                                    <span style="color:#303133"> {{$t('childPayTip')}}</span>
                                  </div>
                                </div>
                            </div>
                            <div class="account-data-order-price">
                                <div class="account-data-info-main">
                                    <div>{{value.dateinfo}}</div>
                                    <div style="overflow: hidden; white-space: nowrap; text-overflow: ellipsis;">
                                      <span v-if="language === 'zh'">{{value.parent_room}}（{{value.parent_room_en}}）</span>
                                      <span v-else>{{value.parent_room_en}}</span>
                                      <span class="greenText" v-if="value.breakfast === '1'">
                                      （{{$t('bedBreakfast')}}）
                                      </span>
                                    </div>
                                    <div>{{value.firstname}} {{value.lastname}}</div>
                                    <div style="font-weight:200;position: absolute;bottom: 12px;font-size: 12px; line-height:12px;">
                                      {{$t('creationDate')}}<span v-if="language === 'en'">&nbsp;</span>{{value.create_date}}
                                      <span class="greenText" :class="{'redText': value.cancel === '0'}">
                                      （{{value.cancel_txt}}）
                                      </span>
                                    </div>
                                </div>
                                <!-- <div class="account-data-info-footer"></div> -->
                                <div class="account-data-price-footer">
                                    <div class="account-data-price-info">
                                      <span style="font-size:16px;font-weight: 100;">{{value.currency}}</span>
                                      {{value.price}}
                                    </div>
                                    <div class="account-data-price-button">
                                      <router-link :to="{name: value.order_status === '1' ? 'WritePay' : 'tripDetail', params: {'querys': common.linkEncode({ orderno: key, 'source': value.source, 'showCancel':1, 'conver': conver }, 'obj')}}">
                                        <a @click="setOrderData(key)">
                                        <button>
                                          {{ value.order_status === '1' ? $t('goPay') : $t('viewDetails') }}
                                          <img style="width:14px;height:14px;margin-bottom:-2px;" src="https://res.roompai.com/static/img/hotelsearch/FFFFFF.png">
                                        </button>
                                        </a>
                                      </router-link>
                                    </div>
                                </div>
                            </div>
                          </div>
                        </div>
                        <div class="account-data-order account-order-mobile" :class="{'account-data-order-morheignt': value.childpay !== ''}">
                          <div class="account-order-paychild" v-if="value.childpay !== ''">
                            {{$t('childPayTip')}}
                          </div>
                          <div class="account-order-info">
                            <div class="account-order-img" v-if="value.pic !== ''">
                                <img :src="value.pic" alt="">
                            </div>
                            <div class="account-order-img" v-else>
                                <img :src="value.dpic" alt="">
                                <div class="no-room-img text-font-hidden">{{$t('nopic')}}</div>
                            </div>
                            <div class="account-order-hotel">
                              <div>
                                <div class="account-order-hotel-info" v-if="language === 'zh'">{{value.hotelname_zh}}<span v-if="value.hotelname !== ''">（{{value.hotelname}}）</span></div>
                                <div class="account-order-hotel-info" v-else>{{value.hotelname}}</div>
                              </div>
                              <div style=" height: 50px; margin-top: 15px;">
                                <div style="width:100%;height: 22px;line-height: 22px;">
                                  <div class="account-order-hotel-orderno">
                                    <span v-if="language === 'zh'">{{$t('bookingReferenceNo')}}<a style="color: #5392F9;font-weight: 400;">{{value.orderno}}</a></span>
                                    <span v-else>{{$t('bookingReferenceNo')}} <a style="color: #5392F9;font-weight: 400;">{{value.orderno}}</a></span>
                                    <span>
                                      <span :class="'tag-order-status-'+language" class="tag-payment" v-if="value.order_status==='1'">{{$t('unpaid')}}</span>
                                      <span :class="'tag-order-status-'+language" class="tag-noconfirm" v-else-if="value.order_status==='2'">{{$t('pending')}}</span>
                                      <span :class="'tag-order-status-'+language" class="tag-confirm" v-else-if="value.order_status==='3' || value.order_status==='6'">{{$t('confirmed')}}</span>
                                      <span :class="'tag-order-status-'+language" class="tag-cancel" v-else>{{$t('cancelled')}}</span>
                                    </span>
                                  </div>
                                </div>
                                <div style="width: 87%; float: left;height: 22px; line-height: 22px;">
                                  <div class="account-order-hotel-orderdate" v-if="value.order_status !== '4'">
                                    <span v-if="language === 'zh'">{{$t('creationDate')}}{{value.create_date}}</span>
                                    <span v-else>{{$t('creationDate')}} {{value.create_date}}</span>
                                  </div>
                                  <div class="account-order-hotel-orderdate" style="color:#E12D2D;" v-else>
                                    <span v-if="language === 'zh'">{{$t('cancellationDate')}}{{value.cancel_date}}</span>
                                    <span v-else>{{$t('cancellationDate')}} {{value.cancel_date}}</span>
                                  </div>
                                </div>
                                <div class="account-order-detail">
                                  <router-link :to="{name: value.order_status === '1' ? 'WritePay' : 'tripDetail', params: {'querys': common.linkEncode({ orderno: key, 'source': value.source, 'showCancel':1, 'conver': conver }, 'obj')}}">
                                    <a @click="setOrderData(key)">
                                    <i class="el-icon-arrow-right" style="color: #999;"></i>
                                    </a>
                                  </router-link>
                                </div>
                              </div>
                            </div>
                          </div>
                          <div class="account-order-data">
                            <div class="account-order-checkin">
                              <div class="account-order-checkin-date">
                                <div>{{$t('checkIn')}}</div>
                                <div style="color:#5392F9">{{value.checkin_val}}</div>
                              </div>
                              <div class="account-order-checkin-line">
                                <i class="el-icon-right" style="color:#999999;"></i>
                              </div>
                              <div class="account-order-checkin-date">
                                <div>{{$t('checkOut')}}</div>
                                <div style="color:#5392F9">{{value.checkout_val}}</div>
                              </div>
                            </div>
                            <div class="account-order-night">
                              <div>{{$t('night')}}<span v-if="value.wan !== '1' && language === 'en'">s</span></div>
                              <div style="color:#5392F9">{{value.wan}}</div>
                            </div>
                            <div class="account-order-night">
                              <div>{{$t('between')}}<span v-if="value.roomcount !== '1' && language === 'en'">s</span></div>
                              <div style="color:#5392F9">{{value.roomcount}}</div>
                            </div>
                          </div>
                        </div>
                        <div class="clearBoth order-room-clear"></div>
                      </div>
                    </template>
                  </el-skeleton>
                </div>
                <div class="account-data-page">
                  <el-pagination background :page-size="pageSize"  @size-change="handleSizeChange" @current-change="handleCurrentChange" :pager-count="7" layout="prev, pager, next" :total="listTotal" :current-page="currentPage" > </el-pagination>
                </div>
              </div>
            </div>
          </div>
      </div>
  </el-main>
  <div class="clearBoth"></div>
  <publicFooter></publicFooter>
</el-container>
</template>

<script>
import { getTripList } from '@/request/order.js'
import publicFooter from '@/components/public/publicFooter'
import publicHeader from '@/components/public/publicHeader'
import publicAccountMenu from '@/components/public/publicAccountMenu'
export default {
  name: 'MyTrip',
  components: {
    publicFooter,
    publicHeader,
    publicAccountMenu
  },
  data () {
    return {
      orderno: '',
      allOrdersShow: true,
      waitPayShow: false,
      upComingShow: false,
      completedShow: false,
      cancelledShow: false,
      tripEmptyShow: false,
      tripListShow: true,
      type: 'allOrders',
      listInfo: [],
      currentPage: 1, // 当前默认显示第几页
      listTotal: 0, // 分页总条数
      pageSize: 20, // 每页显示多少条数据，记住这里一定要是10的倍数，不然无效
      emptyText: '没有可查询的订单哦~',
      emptyTextArr: {
        'zh': {
          'allOrders': '没有可查询的订单哦~',
          'waitPay': '没有待支付的订单哦~',
          'upcoming': '没有即将入住的订单哦~',
          'completed': '没有已完成的订单哦~',
          'cancelled': '没有已取消的订单哦~'
        },
        'en': {
          'allOrders': 'You have no bookings~',
          'waitPay': 'You have no unpaid bookings~',
          'upcoming': 'You have no upcoming bookings~',
          'completed': 'You have no completed bookings~',
          'cancelled': 'You have no cancelled bookings~'
        }
      },
      keyword: '',
      language: this.common.languageSet(this),
      currency: this.common.currencySet(this),
      currencyShow: false, // 币种是否显示
      ismobile: false,
      elementWidth: document.documentElement.clientWidth * 0.95 - 90,
      source: 'roompai',
      listMinHeight: document.documentElement.clientHeight - 181,
      mainMinHeight: document.documentElement.clientHeight - 60 - 241,
      conver: ''
    }
  },
  mounted () {
    if (document.documentElement.clientWidth < 1001) {
      this.ismobile = true
    } else {
      this.ismobile = false
    }
    var source = this.common.linkQuerys.source
    if (source !== '' && source !== undefined && source !== null) {
      this.source = source
    }
    var conver = this.common.linkQuerys.conver
    if (conver === 1 || conver === '1') {
      this.conver = conver
    }
    this.getList(this.currentPage)
    this.emptyText = this.emptyTextArr[this.language]['allOrders']
  },
  watch: {
    language: function (newCur, oldCur) {
      this.getList(this.currentPage)
      this.emptyText = this.emptyTextArr[this.language]['allOrders']
    }
  },
  methods: {
    setOrderData (orderno) {
      console.log(orderno)
      console.log(this.listInfo[orderno])
      if (this.listInfo[orderno].waitingPayData !== '') {
        localStorage.setItem('orderData', JSON.stringify(this.listInfo[orderno].waitingPayData))
        sessionStorage.setItem('productStr', this.listInfo[orderno].waitingPayData.product)
        sessionStorage.setItem('hotelQuotedPriceSesstionId', this.listInfo[orderno].waitingPayData.sesstionid)
      }
    },
    hotelLanguage (language) {
      this.language = language
    },
    clickActive: function (type) {
      this.tripListShow = true
      this.tripEmptyShow = false
      this.type = type
      // 默认都不展示.
      this.allOrdersShow = false
      this.waitPayShow = false
      this.upComingShow = false
      this.completedShow = false
      this.cancelledShow = false
      // 指定的tab显示为true.
      if (type === 'allOrders') {
        this.allOrdersShow = true
      } else if (type === 'waitPay') {
        this.waitPayShow = true
      } else if (type === 'upcoming') {
        this.upComingShow = true
      } else if (type === 'completed') {
        this.completedShow = true
      } else if (type === 'cancelled') {
        this.cancelledShow = true
      }
      this.emptyText = this.emptyTextArr[this.language][type]
      this.getList(this.currentPage)
    },
    searchOrderNo () {
      this.getList(1)
    },
    clearOrderNo () {
      this.keyword = ''
      this.getList(1)
    },
    mobileClearOrderNo () {
      this.keyword = ''
    },
    // 分页 size-change  pageSize 改变时会触发 每页条数
    handleSizeChange (val) {
      this.pageSize = val
    },
    // current-change  currentPage 改变时会触发  当前页
    async handleCurrentChange (val) {
      // this.start = (val - 1) * this.pageSize // （val-1）是我自己的项目需要，一般写val即可
      // localStorage.setItem('page', val)
      this.currentPage = val
      this.getList(val)
    },
    checkKeyword () {
      this.keyword = this.keyword.replace(/[\u4e00-\u9fa5/\s+/]|[^a-zA-Z0-9\u4E00-\u9FA5]/g, '')
      this.keyword = this.keyword.toUpperCase()
    },
    getList (currentPage) {
      this.common.stopScroll()
      var newQuerys = this.common.linkEncode({'source': this.source}, 'obj')
      if (this.conver === 1 || this.conver === '1') {
        newQuerys = this.common.linkEncode({'source': this.source, 'conver': this.conver}, 'obj')
      }
      var time = parseInt(new Date().getTime() / 1000)
      var token = localStorage.getItem('token')
      if (token === undefined || token === null || token === 'null') {
        let locationHref = window.document.location.href
        sessionStorage.setItem('LoginWebsiteAddress', locationHref)
        this.$router.push({name: 'login', params: {'querys': newQuerys}})
      }
      var sessionid = this.common.sessionidGet(this)
      var dataJson = {
        'orderno': this.keyword,
        'type': this.type,
        'page': currentPage,
        'time': time,
        'language': this.language,
        'currency': this.currency,
        'source': this.source,
        'token': token,
        'sessionid': sessionid
      }
      var data = this.common.encryptionData(dataJson, this)
      console.log(data)
      getTripList(data).then(res => {
        console.log(res)
        if (res.flag === '001') {
          let locationHref = window.document.location.href
          sessionStorage.setItem('LoginWebsiteAddress', locationHref)
          this.$router.push({name: 'login', params: {'querys': newQuerys}})
        } else if (res.flag === '200') {
          this.listInfo = res.data.list
          this.listTotal = parseInt(res.data.totalNum)
          this.currentPage = parseInt(res.data.currentPage)
          this.pageSize = parseInt(res.data.pageSize)
          this.tripEmptyShow = false
          this.tripListShow = false
          this.common.canScroll()
        } else {
          this.listInfo = []
          this.tripEmptyShow = true
          this.tripListShow = false
          this.currentPage = 1
          this.listTotal = 0
          this.pageSize = 20
        }
      })
    },
    handleKeyUp () {
      this.getList(1)
    },
    goback: function () {
      var LoginWebsiteAddress = sessionStorage.getItem('LoginWebsiteAddress')
      if (LoginWebsiteAddress !== null && LoginWebsiteAddress.indexOf('login/login') === -1) {
        window.document.location.href = LoginWebsiteAddress
      } else {
        var newQuerys = this.common.linkEncode({'source': this.source}, 'obj')
        if (this.conver === 1 || this.conver === '1') {
          newQuerys = this.common.linkEncode({'source': this.source, 'conver': this.conver}, 'obj')
        }
        this.$router.push({name: 'Home', params: {'querys': newQuerys}})
      }
    }
  }
}
</script>

<style scoped>
.el-main{text-align: left;}
.main{background-color: #fff;width:100%;position:relative;min-height: 600px;}

/* PC */
  /* 右侧 */
  .account-show{width: 100%; height: 100%;background:#FFFFFF;}
  .account-show .account-center{width: 82%;height:100%; float:right;background: #FFFFFF;}
  .account-center .account-data-info{width:70%;height:100%;margin:0 auto;}
  .account-data-info .account-data-search{width:100%;height:100px;line-height:100px;font-family: PingFangSCRegular, 'PingFang SC Medium', 'PingFang SC', sans-serif; font-weight: 500;font-style: normal;color: #4F4C4C;font-size:14px;overflow:hidden;}

  /* 单号搜索 */
  .account-data-search input{width: 33%; border-radius: 4px;border: solid 1px #DCDFE2;margin-left: 15px;}
  .account-data-search input:focus{border-color:rgb(252, 210, 5, 1);box-shadow: 0px 0px 8px rgb(252 210 5);}
  .account-data-search .account-button{height: 38px; border-radius: 4px;overflow: hidden; white-space: nowrap;}
  .account-data-search .button-search{margin-left:15px;font-weight: 500;border: solid 1px rgba(79, 76, 76, 1);color: #FFFFFF;width: 80px;height: 40px;background: inherit;background-color: rgba(79, 76, 76, 1);box-sizing: border-box;border-radius: 6px;}
  .account-data-search .button-report{margin-left:5px;width: 80px;height: 38px;background: inherit;background-color: rgba(79, 76, 76, 0.047058823529411764);box-sizing: border-box;border: solid 1px rgba(79, 76, 76, 1);border-radius: 6px;font-weight: 500;font-style: normal;color: #4F4C4C;}
  .account-data-search button:hover{background:rgba(252, 210, 5, 1);color:#4F4C4C;border:1px solid rgba(252, 210, 5, 1);}
  .account-data-search .el-input{width: 336px; }
  .mobile-keyword /deep/ .el-input__prefix{left:0px; right:5px; text-align: right; height:0;}
  .account-data-search .el-input__icon{height: 40px !important;}
  .mobile-keyword /deep/ .el-input__inner{ padding-left: 15px; padding-right: 30px;}
  /* 状态搜索 */
  .account-data-status{width: 100%; height: 60px;}
  .account-data-status .account-data-status-center{width: 100%; height: 40px; background:white;margin:0 auto;border-radius: 5px;box-shadow: 1px 1px 2px #dcdfe2;}
  .account-data-status-center div:hover{color:#5392F9;}
  .account-data-status-center div{cursor: pointer; width: 25%;height: 100%;text-align: center;line-height: 40px;float: left;font-family: PingFangSCRegular, 'PingFang SC Semibold', 'PingFang SC', sans-serif;font-weight: 650;font-style: normal;font-size: 14px;color: #303133;box-shadow: 1px 0 1px #dcdfe2;overflow: hidden; white-space: nowrap;}
  .account-data-status-center .status-first{border-radius: 5px 0px 0px 5px;}
  .account-data-status-center .status-last{border-radius: 0px 5px 5px 0px;}
  .account-data-status-center .status-active{background:#5392F9;color:white;}
  .account-data-status-center .status-active:hover{color:white;}

  /* 详情 */
  .account-data-empty{width:100%;min-height:600px;text-align: center;padding-top: 40px;}
  .content-empty-text{font-size: 14px;color: #4F4C4C;text-align: center; margin-top: 10px;}
  .content-empty-img{width:200px; height:200px;}
  .account-data-detail{width:100%;min-height:600px;}
  .account-data-detail .account-data-order{width:100%;height: 164px;border: solid 1px #DCDFE2;border-radius: 3px;background-color: white;position: relative;}
  .account-data-detail .account-data-order-morheignt{height:194px !important;}
  .account-data-detail .account-data-order:hover{box-shadow: 0px 6px 12px rgb(0 0 0 / 20%); border: 1px solid rgb(0 0 0 / 5%);border-radius: 4px;}
  .account-data-order .account-data-order-img{height: 100%;width: 25%;float:left;border-radius: 3px 0px 0px 3px;position: relative;}
  .account-data-order-img img{height: 100%;width: 100%;border-radius: 3px 0px 0px 3px;}
  .account-data-order .account-data-order-img .no-room-img,.account-order-info .account-order-img .no-room-img{bottom:45px;height:35px;line-height:35px;}
  .account-data-order .account-data-order-img .text-font-hidden,.account-order-info .account-order-img .text-font-hidden{position:absolute;bottom:12px;width:100%;font-size: 14px;color: #FFFFFF;border-radius:0px 0px 4px 4px;background:rgba(70, 37, 36, 0.5);cursor:pointer;
      text-align: center;overflow: hidden;white-space: nowrap;text-overflow: ellipsis;}
  .account-data-order .account-data-order-info{width:100%;min-height:67px;background:white;float:left; margin-bottom: 10px;}
  .account-data-order-info .account-data-info-top{font-weight: 650;font-style: normal;font-size: 16px;color: #303133;margin-top:10px;margin-left:10px;width: 50%;height: 20px;float:left;line-height:20px;}
  .account-data-order-price .account-data-info-main{margin-left:10px;float: left;font-weight: 350; font-style: normal;font-size: 13px;color: #939695;width: 70%;height: 50%;white-space: nowrap; line-height:20px;}
  .account-data-order-price .account-data-info-footer{margin-left:10px;font-weight: 200; font-style: normal;font-size: 13px;color: #939695;width: 70%;height: 11%;}
  .account-data-order .account-data-order-price{width:100%;background:white;clear:both;font-size: 14px;border-radius: 0px 3px 3px 0px;}
  .account-data-order-price .account-data-price-top-zh{margin-top:10px;padding-right:10px;width:96%;height:40%;}
  .account-data-order-price .account-data-price-top-en{margin-top:10px;width:99%;height:40%;}

  .child-pay-tip{height:20px; background-color:rgba(252, 210, 5, 1); text-align: center;float: right;padding: 0px 10px; margin-top:3px;}
  .account-order-paychild{height: 30px; background-color: rgba(252, 210, 5, 1);text-decoration: none;line-height: 30px;font-size: 14px;font-weight: 650;text-align: right;}
  .account-data-detail a{text-decoration:none;}
  .account-data-order-price .account-data-price-footer{width: 150px;float: right;text-align: right;position: absolute;right: 12px;bottom: 12px;}
  .account-data-price-footer .account-data-price-info{font-family: PingFangSCRegular, 'PingFang SC Semibold', 'PingFang SC', sans-serif;font-weight: 650;font-size: 22px;color: #E12D2D;width:100%;height:45%;}
  .account-data-price-button button{width: 105px;height: 40px;background-color: #5392F9;border: none;border-radius: 3px;color: white; margin-top: 10px; cursor: pointer;}
  .account-data-price-button button:hover{background-color: #3E6CEA;}
  /* 分页 */
  .account-data-page{width:100%;height:50px;text-align:right;}
  .account-data-page .el-pagination.is-background .el-pager li,.account-data-page .el-pagination.is-background .btn-prev,.account-data-page .el-pagination.is-background .btn-next{background:white;}

/* 手机 */
  .account-order-mobile{width:100%;font-family: PingFangSCRegular, 'PingFang SC Semibold', 'PingFang SC', sans-serif;font-style: normal;color: #303133;box-shadow: 0 6px 12px 0 #dcdfe2;}
  .account-order-mobile .account-order-info{width:100%;height:114px;background:white;}
  .account-order-mobile .account-order-info div{float:left;}
  .account-order-mobile .account-order-info .account-order-img{width:20%;height:100%; position: relative;}
  .account-order-mobile .account-order-info .account-order-img img{width:100%;height:100%;object-fit: cover;}
  .account-order-mobile .account-order-info .account-order-hotel{width:77%;height:100%;}
  .account-order-mobile .account-order-info .account-order-hotel div{overflow:hidden;text-overflow: ellipsis;}
  .account-order-mobile .account-order-info .account-order-hotel .account-order-hotel-info{width:100%; padding-top: 2px; padding-left: 1rem;font-weight: 550;font-size: 16px;height: 40%;}
  .account-order-mobile .account-order-info .account-order-hotel .account-order-hotel-status{width:100%; padding-top: 15px; padding-left: 1rem;font-weight: 150;font-size: 14px;}
  .account-order-mobile .account-order-info .account-order-hotel .account-order-hotel-orderno{width:100%; padding-left: 10px;font-weight: 400;font-size: 10px;overflow:hidden;text-overflow: ellipsis;white-space: nowrap;}
  .account-order-mobile .account-order-info .account-order-hotel .account-order-hotel-orderdate{width:100%; padding-left: 10px;font-weight: 400;font-size: 10px;overflow:hidden;text-overflow: ellipsis;white-space: nowrap;}
  .account-order-mobile .account-order-info .account-order-detail{width:10%;height:22px;float:right;line-height: 22px;text-align: center;overflow: hidden;color:#999999; font-size: 20px;}
  .account-order-mobile .account-order-data{width:100%;height:50px;border-top: solid 1px #dcdfe2;}
  .account-order-mobile .account-order-data .account-order-checkin{width:60%;height:100%;background:white;float:left;text-align: center;}
  .account-order-mobile .account-order-data .account-order-checkin .account-order-checkin-date{width:49%;height:100%;float:left;overflow:hidden;font-size: 10px; color: #999999;padding:5px 0;}
  .account-order-mobile .account-order-data .account-order-checkin .account-order-checkin-date div{width:100%;height:20px; line-height:20px; float:left;overflow:hidden;}
  .account-order-mobile .account-order-data .account-order-checkin .account-order-checkin-line{width:2%;height:100%;float:left;line-height:20px;padding-top: 5px;}
  .account-order-mobile .account-order-data .account-order-night{width:20%;height:40px;background:white;float:left;text-align: center; font-size: 10px; color: #999999; padding:5px 0;box-shadow: 0 1px 1px 1px #dcdfe2;}
  .account-order-mobile .account-order-data .account-order-night div{width:100%;height:20px; line-height:20px; float:left;overflow:hidden;}

  .account-order-mobile .account-order-data .account-order-room{width:20%;height:100%;background:white;float:left;line-height: 70px;text-align: center; box-shadow: 0 1px 1px 1px #dcdfe2;}

/* 分页 */
.account-data-info .account-data-page{width: 100%;overflow-x: auto; margin-top: 100px;}
.account-data-info .account-data-page::-webkit-scrollbar { display: none;}
.el-main::-webkit-scrollbar { display: none;}

.tag-order-status-zh{font-weight: 500;font-style: normal;font-size: 12px;padding: 3px 15px;margin-right: 10px;}
.tag-order-status-en{font-weight: 500;font-style: normal;font-size: 12px;padding: 3px;}
.tag-confirm{color: #67C23A;background:#EEF9E9;}
.tag-noconfirm{color: #EBB563;background:#FFF6EC;}
.tag-cancel{color: #66B1FF;background:#E9F5FF;}
.tag-payment{color: #F78989;background:#FFEFF0;}
.order-room-clear{height:15px;}
.greenText{color:#2F7000;}
.redText{color:#E12D2D;}

/* 响应式 */
  @charset "UTF-8";

  /* @media only screen and (min-width:390px) and (max-width:490px){
      .main .menu-main{display:none}
      .main .account-show .account-center{width:100%;}
      .main .account-show .account-center .account-data-info{width:95%;}
      .main .account-show .account-center .account-data-info .account-order-pc{display:none;}
      .main .account-show .account-center .account-data-info .account-order-mobile{}
  } */

  @media only screen and (max-width:1099px){
    .main .menu-main{display:none}
    .main .account-show .account-center{width:100%;}
    .main .account-show .account-center .account-data-info{width:95%;}
    .main .account-show .account-center .account-data-info .account-order-pc{display:none;}
    /* .account-data-search .el-input{width: 60% !important; } */
    .account-order-mobile .account-order-info .account-order-hotel .account-order-hotel-info{font-size:14px; font-weight: 650; padding: 10px 0px 0px 10px;height:40px;}
    .tag-order-status-zh{padding: 3px 5px;}
    .account-order-mobile .account-order-info .account-order-hotel div{overflow: unset;}
    .account-data-search .button-search{margin-left: 5px;}
    .account-order-paychild{ padding-right:5%;}
  }

  @media only screen and (min-width:1100px) {
    .el-main{width:1100px;margin:60px auto;}
    .main{background-color: #fff;position:relative;min-height: 600px;width:100%; margin: auto;}
    /* .menu-main{width: 255px;height: 100%;float: left;background-color: rgba(255, 255, 255, 1);border-right: none;-webkit-box-shadow: 0 2px 12px #ccc;box-shadow: 4px -2px 5px -3px #ccc;position: fixed;top: 60px;bottom: 300px;} */
    .menu-main{width: 255px;float: left;position: fixed;top: 60px;bottom: 360px;height: 100%}
    .main .account-show .account-center{width:100%;}
    .main .account-show .account-center .account-data-info{width:100%;}
    .main .account-show .account-center .account-data-info .account-order-pc{}
    .main .account-show .account-center .account-data-info .account-order-mobile{display:none;}
    .account-show{width: 825px; height: 100%;background:#FFFFFF;float: right;padding: 0 10px;}
  }

  /* @media only screen and (min-width:1400px) {
      .menu-left{width: 18%;height: 100%;position:fixed;left:0px;z-index:99;background-color: rgba(255, 255, 255, 1);border-right:solid 1px #ccc;box-shadow: 0 2px 12px #ccc;}
      .menu-main{clear:both;}
      .main .account-show .account-center .account-data-info .account-order-pc{}
      .main .account-show .account-center .account-data-info .account-order-mobile{display:none;}
  } */
</style>



// WEBPACK FOOTER //
// src/components/account/myTrip.vue